import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'CZK',
    showClickAndCollect: false,
    showEcoFee: true,
    enableEnergyLabelLink: true,
};
